export default __webpack_public_path__ + "static/media/news4.35c11750.jpg";